import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'src/app/shared/message/message.service';
import { UserService } from 'src/app/user/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false
})
export class ResetPasswordComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private userService = inject(UserService);
  private messageService = inject(MessageService);

  recoverForm = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)])
  });

  isLoading = false;
  error = null;
  token: string;
  username: string;

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'];
    this.username = this.route.snapshot.queryParams['username'];
  }

  get recover() {
    return this.recoverForm.controls;
  }

  checkError(): string {
    const password = this.recoverForm.get('password').value;
    const confirmPassword = this.recoverForm.get('confirmPassword').value;
    if (this.recover['password'].errors) {
      return 'รหัสผ่านมีความยาวอย่างน้อย 6 ตัวอักษร';
    } else if (this.recover['confirmPassword'].errors) {
      return 'กรุณายืนยันรหัสผ่าน';
    } else if (password !== confirmPassword) {
      this.recoverForm.get('confirmPassword').setValue('');
      return 'รหัสผ่านไม่ตรงกัน';
    }
    return '';
  }

  resetPassword() {
    if (!this.recoverForm.valid) {
      return;
    }
    this.isLoading = true;
    this.error = this.checkError();
    if (this.error === '') {
      const password = this.recoverForm.get('password').value;
      this.userService.resetPassword(this.username, this.token, password).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['sign-in']);
          this.messageService.message = 'ระบบได้ทำการเปลี่ยนรหัสผ่านใหม่เรียบร้อยแล้ว';
        },
        error: (err) => {
          this.isLoading = false;
          this.error = err?.error?.message;
          this.recoverForm.get('confirmPassword').setValue('');
        }
      });
    } else {
      this.isLoading = false;
    }
  }
}
